import { createElement } from 'react';
import type { ReactNode } from 'react';

import WorkspacesRoundedIcon from '@mui/icons-material/WorkspacesRounded';
import { Resources } from '@ragu-components/ord-resources';
import { useGetRecordRepresentation } from 'react-admin';

import type { Agent } from '@ragu-components/ord-types';

export interface AgentDisplayInfo {
  label: ReactNode;
  avatarId: string | undefined;
  avatarResource: string | undefined;
  avatarMeta: { name?: string; surname?: string } | undefined;
  avatarIcon: ReactNode | undefined;
}

/**
 * Hook that extracts display information from an Agent record.
 * Handles the user vs group logic internally.
 */
export const useAgentDisplay = (agent: Agent): AgentDisplayInfo => {
  const userRepresentation = useGetRecordRepresentation(Resources.users);
  const groupRepresentation = useGetRecordRepresentation(Resources.groups);

  if (agent.user !== null && agent.user !== undefined) {
    return {
      label: typeof userRepresentation === 'function' ? userRepresentation(agent.user) : agent.user.id,
      avatarId: agent.user.id,
      avatarResource: 'users',
      avatarMeta: { name: agent.user.firstname, surname: agent.user.lastname },
      avatarIcon: undefined,
    };
  }

  if (agent.group !== null && agent.group !== undefined) {
    return {
      label: typeof groupRepresentation === 'function' ? groupRepresentation(agent.group) : agent.group.id,
      avatarId: undefined,
      avatarResource: undefined,
      avatarMeta: undefined,
      avatarIcon: createElement(WorkspacesRoundedIcon, { sx: { fontSize: 16 } }),
    };
  }

  return {
    label: agent.id,
    avatarId: undefined,
    avatarResource: undefined,
    avatarMeta: undefined,
    avatarIcon: undefined,
  };
};
